export default {
  namespaced: true,
  state: {
    showShoppingLists: false,
  },
  getters: {
    showShoppingLists: state => state.showShoppingLists,
  },
  actions: {
    setShoppingListsVisibility: ({ commit }, boolean) => {
      commit("setShoppingListsVisibility", boolean);
    },
  },
  mutations: {
    setShoppingListsVisibility: (state, boolean) => {
      state.showShoppingLists = boolean;
    },
  },
};
